// Bandeiras de voucher do SiTef.
//
// Fonte: "Bandeira do SiTef - Codigo de Bandeiras Padrao - Servico 1",
// Software Express, versao 2.60 patch 361, paginas 6 a 31.
//
// Contem apenas os codigos cujo campo "Tipo" e Voucher ou uma de suas
// variantes (Refeicao, Alimentacao, Cultura, Beneficio, Farmacia). Codigos de
// credito, debito, gift, combustivel e carteira digital ficaram de fora.
//
// A chave e o codigo devolvido pelo SiTef no campo 132, gravado em
// tefTerminal.response.processTypeCard, sempre com 5 digitos.

export const SITEF_VOUCHER_BRANDS = {
  "10001": { brand: "Ticket", type: "Voucher" },
  "10002": { brand: "Visa", type: "Voucher" },
  "10004": { brand: "Nutricash", type: "Voucher" },
  "10005": { brand: "Greencard", type: "Voucher" },
  "10006": { brand: "Planvale", type: "Voucher" },
  "10007": { brand: "Banquet", type: "Voucher" },
  "10008": { brand: "Verocheque", type: "Voucher" },
  "10009": { brand: "Sapore", type: "Voucher" },
  "10010": { brand: "BNBClube", type: "Voucher" },
  "10011": { brand: "Valecard", type: "Voucher" },
  "10012": { brand: "Cabal", type: "Voucher" },
  "10014": { brand: "Diners", type: "Voucher" },
  "10019": { brand: "Alelo", type: "Voucher" },
  "10021": { brand: "Alelo", type: "Voucher Refeicao" },
  "10022": { brand: "Alelo", type: "Voucher Alimentacao" },
  "10023": { brand: "Alelo", type: "Voucher Cultura" },
  "10024": { brand: "Ticket", type: "Voucher Refeicao" },
  "10025": { brand: "Ticket", type: "Voucher Alimentacao" },
  "10027": { brand: "Ticket", type: "Voucher Cultura" },
  "10028": { brand: "Sodexo", type: "Voucher Refeicao" },
  "10029": { brand: "Sodexo", type: "Voucher Alimentacao" },
  "10031": { brand: "Sodexo", type: "Voucher" },
  "10032": { brand: "Sodexo", type: "Voucher Cultura" },
  "10037": { brand: "Sorocred", type: "Voucher" },
  "10039": { brand: "Valemulti", type: "Voucher" },
  "10040": { brand: "Valefrota", type: "Voucher" },
  "10044": { brand: "Coopercred", type: "Voucher" },
  "10046": { brand: "Valefacil", type: "Voucher" },
  "10047": { brand: "VR", type: "Voucher Refeicao" },
  "10048": { brand: "VR", type: "Voucher Alimentacao" },
  "10050": { brand: "VR", type: "Voucher Cultura" },
  "10051": { brand: "Planvale", type: "Voucher Cultura" },
  "10052": { brand: "Refeisul", type: "Voucher Cultura" },
  "10053": { brand: "Nutricash", type: "Voucher Cultura" },
  "10055": { brand: "Valecard", type: "Voucher Cultura" },
  "10056": { brand: "Coopercred", type: "Voucher Cultura" },
  "10070": { brand: "VR", type: "Voucher Beneficio" },
  "10071": { brand: "Planvale", type: "Voucher Beneficio" },
  "10072": { brand: "Planvale", type: "Voucher Alimentacao" },
  "10073": { brand: "Planvale", type: "Voucher Refeicao" },
  "10075": { brand: "Planvale", type: "Voucher Farmacia" },
  "10077": { brand: "Libercard", type: "Voucher" },
  "10083": { brand: "VR", type: "Voucher" },
  "10089": { brand: "Refeisul", type: "Voucher Alimentacao" },
  "10090": { brand: "Verocheque", type: "Voucher Cultura" },
  "10110": { brand: "Vale Express", type: "Voucher" },
  "10116": { brand: "HubPrePaid", type: "Voucher" },
  "10122": { brand: "Telenet", type: "Voucher" },
  "10129": { brand: "Softnex", type: "Voucher" },
  "10132": { brand: "Goodcard", type: "Voucher" },
  "10133": { brand: "Goodcard", type: "Voucher Refeicao" },
  "10134": { brand: "Goodcard", type: "Voucher Alimentacao" },
  "10137": { brand: "Coopercred", type: "Voucher Alimentacao" },
  "10138": { brand: "Coopercred", type: "Voucher Refeicao" },
  "10140": { brand: "Ben VisaVale", type: "Voucher Refeicao" },
  "10141": { brand: "Ben VisaVale", type: "Voucher Alimentacao" },
  "10142": { brand: "Abrapetite", type: "Voucher" },
  "10143": { brand: "AvanCard", type: "Voucher" },
  "10144": { brand: "Biq", type: "Voucher" },
  "10146": { brand: "Volus", type: "Voucher" },
  "10147": { brand: "Convenios Card", type: "Voucher" },
  "10149": { brand: "CrediAlimentacao", type: "Voucher" },
  "10150": { brand: "Eucard", type: "Voucher" },
  "10151": { brand: "FaceCard", type: "Voucher" },
  "10152": { brand: "Fleetcard", type: "Voucher" },
  "10153": { brand: "Lecard", type: "Voucher" },
  "10154": { brand: "Nutricard", type: "Voucher" },
  "10156": { brand: "REDEPLUS", type: "Voucher" },
  "10157": { brand: "Usecred", type: "Voucher" },
  "10158": { brand: "Valeshop", type: "Voucher" },
  "10159": { brand: "Vegascard", type: "Voucher" },
  "10160": { brand: "VS Card", type: "Voucher" },
  "10162": { brand: "Policard", type: "Voucher" },
  "10164": { brand: "Policard", type: "Voucher Alimentacao" },
  "10165": { brand: "Policard", type: "Voucher Refeicao" },
  "10169": { brand: "Senff", type: "Voucher Alimentacao" },
  "10170": { brand: "Senff", type: "Voucher Refeicao" },
  "10171": { brand: "Senff", type: "Voucher" },
  "10173": { brand: "Greencard", type: "Voucher Alimentacao" },
  "10174": { brand: "Greencard", type: "Voucher Refeicao" },
  "10175": { brand: "Greencard", type: "Voucher Cultura" },
  "10176": { brand: "Verocheque", type: "Voucher Alimentacao" },
  "10177": { brand: "Verocheque", type: "Voucher Refeicao" },
  "10178": { brand: "Policard", type: "Voucher Cultura" },
  "10182": { brand: "PersonalCard", type: "Voucher" },
  "10183": { brand: "LifeCard", type: "Voucher" },
  "10184": { brand: "TrioCard", type: "Voucher" },
  "10185": { brand: "ACCredito", type: "Voucher" },
  "10190": { brand: "Azul Card", type: "Voucher" },
  "10191": { brand: "BandCard", type: "Voucher Alimentacao" },
  "10192": { brand: "Banese", type: "Voucher Refeicao" },
  "10193": { brand: "Bank", type: "Voucher" },
  "10194": { brand: "BiCartoes", type: "Voucher" },
  "10195": { brand: "Bigcard", type: "Voucher" },
  "10196": { brand: "Bluebank", type: "Voucher" },
  "10197": { brand: "CampeloCard", type: "Voucher Alimentacao" },
  "10198": { brand: "Cartao Confianca", type: "Voucher" },
  "10199": { brand: "Irani", type: "Voucher" },
  "10200": { brand: "Irani", type: "Voucher Alimentacao" },
  "10201": { brand: "Clube Demais", type: "Voucher Alimentacao" },
  "10202": { brand: "Condor", type: "Voucher Alimentacao" },
  "10203": { brand: "Ediz", type: "Voucher" },
  "10204": { brand: "Enscon Card", type: "Voucher" },
  "10205": { brand: "Formosa", type: "Voucher" },
  "10206": { brand: "GiraCard", type: "Voucher" },
  "10207": { brand: "Idealcard", type: "Voucher" },
  "10208": { brand: "Imperatriz", type: "Voucher" },
  "10209": { brand: "Neus", type: "Voucher" },
  "10210": { brand: "Neus Minas", type: "Voucher" },
  "10211": { brand: "PagueMenos", type: "Voucher Alimentacao" },
  "10212": { brand: "PG Card", type: "Voucher" },
  "10213": { brand: "Queiroz Premium", type: "Voucher" },
  "10214": { brand: "Queiroz Premium", type: "Voucher Alimentacao" },
  "10215": { brand: "SindConvenios", type: "Voucher" },
  "10216": { brand: "Sollus", type: "Voucher Alimentacao" },
  "10217": { brand: "Sollus", type: "Voucher Refeicao" },
  "10218": { brand: "SuperCred", type: "Voucher" },
  "10219": { brand: "ValeMais", type: "Voucher" },
  "10220": { brand: "ValeMais", type: "Voucher Alimentacao" },
  "10221": { brand: "Valle Real", type: "Voucher Alimentacao" },
  "10222": { brand: "Vegas", type: "Voucher" },
  "10223": { brand: "PagueMenos", type: "Voucher Beneficio" },
  "10224": { brand: "Paracatu Card", type: "Voucher Beneficio" },
  "10225": { brand: "Servir", type: "Voucher Beneficio" },
  "10226": { brand: "Sertao Card", type: "Voucher Beneficio" },
  "10227": { brand: "Sintram", type: "Voucher Beneficio" },
  "10228": { brand: "ValeMais", type: "Voucher Beneficio" },
  "10229": { brand: "Valle Real", type: "Voucher Beneficio" },
  "10230": { brand: "Master", type: "Voucher Alimentacao" },
  "10231": { brand: "Master", type: "Voucher Refeicao" },
  "10232": { brand: "Siapnet", type: "Voucher" },
  "10233": { brand: "Siapnet", type: "Voucher Alimentacao" },
  "10234": { brand: "Siapnet", type: "Voucher Refeicao" },
  "10237": { brand: "Valecard", type: "Voucher Alimentacao" },
  "10238": { brand: "Valecard", type: "Voucher Refeicao" },
  "10241": { brand: "Sysdata", type: "Voucher" },
  "10242": { brand: "Alelo", type: "Voucher Beneficio" },
  "10254": { brand: "Bk Bank", type: "Voucher" },
  "10259": { brand: "Uauh", type: "Voucher Alimentacao" },
  "10260": { brand: "Uauh", type: "Voucher Refeicao" },
  "10261": { brand: "Uauh", type: "Voucher Farmacia" },
  "10262": { brand: "Uauh", type: "Voucher" },
  "10264": { brand: "Romcard", type: "Voucher" },
  "10266": { brand: "Master", type: "Voucher" },
  "10267": { brand: "Amex", type: "Voucher" },
  "10269": { brand: "Sodexo", type: "Voucher Beneficio" },
  "10270": { brand: "Cabal", type: "Voucher Refeicao" },
  "10271": { brand: "Cabal", type: "Voucher Alimentacao" },
  "10272": { brand: "Cabal", type: "Voucher Cultura" },
  "10274": { brand: "Bonus CBA", type: "Voucher" },
  "10276": { brand: "Biq", type: "Voucher Refeicao" },
  "10277": { brand: "BNBClube", type: "Voucher Refeicao" },
  "10280": { brand: "Credialiment", type: "Voucher" },
  "10281": { brand: "Refeisul", type: "Voucher" },
  "10286": { brand: "GPA", type: "Voucher" },
  "10287": { brand: "Banpara", type: "Voucher" },
  "10288": { brand: "Amazoncard", type: "Voucher" },
  "10289": { brand: "Yamada", type: "Voucher" },
  "10290": { brand: "Goiascard", type: "Voucher" },
  "10291": { brand: "Credpar", type: "Voucher" },
  "10292": { brand: "Maxxcard", type: "Voucher" },
  "10293": { brand: "Banese", type: "Voucher" },
  "10307": { brand: "REDEPLUS", type: "Voucher Alimentacao" },
  "10308": { brand: "Usecard", type: "Voucher Alimentacao" },
  "10309": { brand: "Usecard", type: "Voucher Refeicao" },
  "10310": { brand: "Convenios Card", type: "Voucher Alimentacao" },
  "10312": { brand: "Abrapetite", type: "Voucher Refeicao" },
  "10313": { brand: "HubPrePaid", type: "Voucher Alimentacao" },
  "10314": { brand: "HubPrePaid", type: "Voucher Refeicao" },
  "10315": { brand: "Ben VisaVale", type: "Voucher" },
  "10329": { brand: "Bamex", type: "Voucher" },
  "10331": { brand: "ViaSoftPay", type: "Voucher" },
  "10355": { brand: "Sorocred", type: "Voucher Alimentacao" },
  "10356": { brand: "Sorocred", type: "Voucher Refeicao" },
  "10359": { brand: "Nutricash", type: "Voucher Alimentacao" },
  "10360": { brand: "Nutricash", type: "Voucher Refeicao" },
  "10361": { brand: "Nutricash", type: "Voucher Beneficio" },
  "10362": { brand: "Maxxcard", type: "Voucher Alimentacao" },
  "10363": { brand: "Maxxcard", type: "Voucher Refeicao" },
  "10365": { brand: "Maxxcard", type: "Voucher Cultura" },
  "10366": { brand: "Volus", type: "Voucher Alimentacao" },
  "10367": { brand: "Volus", type: "Voucher Refeicao" },
  "10368": { brand: "PersonalCard", type: "Voucher Refeicao" },
  "10371": { brand: "Bk Bank", type: "Voucher Alimentacao" },
  "10372": { brand: "Bk Bank", type: "Voucher Refeicao" },
  "10373": { brand: "PersonalCard", type: "Voucher Alimentacao" },
  "10377": { brand: "008 Cards", type: "Voucher" },
  "10378": { brand: "008 Cards", type: "Voucher Refeicao" },
  "10379": { brand: "008 Cards", type: "Voucher Alimentacao" },
  "10380": { brand: "Fitcard", type: "Voucher" },
  "10394": { brand: "Ticket", type: "Voucher Beneficio" },
  "10398": { brand: "OneCard", type: "Voucher Alimentacao" },
  "10399": { brand: "OneCard", type: "Voucher Refeicao" },
  "10400": { brand: "OneCard", type: "Voucher Cultura" },
  "10401": { brand: "OneCard", type: "Voucher Beneficio" },
  "10410": { brand: "Megavalecard", type: "Voucher" },
  "10414": { brand: "Velozcard", type: "Voucher Alimentacao" },
  "10415": { brand: "SinCard", type: "Voucher Alimentacao" },
  "10416": { brand: "FaceCard", type: "Voucher Alimentacao" },
  "10417": { brand: "Velozcard", type: "Voucher" },
  "10418": { brand: "SinCard", type: "Voucher" },
  "10424": { brand: "QBCard", type: "Voucher Alimentacao" },
  "10427": { brand: "Gocard", type: "Voucher" },
  "10435": { brand: "ViaSoftPay", type: "Voucher Alimentacao" },
  "10436": { brand: "ViaSoftPay", type: "Voucher Refeicao" },
  "10439": { brand: "ACT1", type: "Voucher Refeicao" },
  "10440": { brand: "ACT1", type: "Voucher Alimentacao" },
  "10444": { brand: "Elo Ticket", type: "Voucher" },
  "10445": { brand: "Elo Sodexo", type: "Voucher" },
  "10446": { brand: "Elo Alelo", type: "Voucher" },
  "10447": { brand: "Elo", type: "Voucher" },
  "10464": { brand: "BonusCred", type: "Voucher" }
};

// O SiTef devolve o codigo com 5 posicoes, mas normalizamos para tolerar
// valores sem os zeros a esquerda.
export const getSitefVoucherEntry = code => {
  if (code === null || code === undefined) {
    return null;
  }

  const normalized = String(code).trim();

  if (!normalized) {
    return null;
  }

  return (
    SITEF_VOUCHER_BRANDS[normalized] ||
    SITEF_VOUCHER_BRANDS[normalized.padStart(5, "0")] ||
    null
  );
};

export const getSitefVoucherBrand = code => {
  const entry = getSitefVoucherEntry(code);

  return entry ? entry.brand : null;
};
